<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Export"
      placement="top"
    >
      <el-button
        size="mini"
        :loading="exportButtonLoader"
        icon="el-icon-download"
        @click="exportPackings"
      />
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['packing'],
    data() {
      return {
        exportButtonLoader: false,
      };
    },

    methods: {
       async exportPackings() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/packings/' + this.packing.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'packing_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
